import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, getModule, Vue, Watch } from 'nuxt-property-decorator';
import DefaultMenu from '@template/components/defaultMenu.vue';
import DefaultMenuUser from '@template/components/defaultMenuUser.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import SmallMenu from '@template/components/SmallMenu.vue';
import HorizontalTemplate from '~/template/horizontalTemplate.vue';
import AppModule from '~/store/AppModule';
Vue.use(VueAxios, axios);
var Default = /*#__PURE__*/function (_Vue) {
  _inherits(Default, _Vue);
  var _super = _createSuper(Default);
  function Default() {
    var _this;
    _classCallCheck(this, Default);
    _this = _super.apply(this, arguments);
    /* Props */
    _this.showErrorPopup = false;
    _this.errorPopUpTimer = 8000;
    _this.errorPopUpText = '';
    /* Data */
    _this.appStore = getModule(AppModule);
    return _this;
  }
  _createClass(Default, [{
    key: "showError",
    get: function get() {
      return this.appStore.ErrorState;
    }
    /* Watch */
  }, {
    key: "onErrorChange",
    value: function onErrorChange() {
      if (this.appStore.ErrorState) {
        this.showErrorPopup = true;
        this.errorPopUpText = this.appStore.ErrorMessage;
      }
    }
  }, {
    key: "onVisibilityErrorPopUpChanged",
    value: function onVisibilityErrorPopUpChanged() {
      if (this.showErrorPopup === false) this.appStore.setStateToOk();
    }
    /* Enums */
    /* Lifecycle */
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "mounted",
    value: function mounted() {}
    /* Computed */
    /* Methods */
  }, {
    key: "setShowErrorPopUp",
    value: function setShowErrorPopUp() {
      if (this.appStore.ErrorState) {
        this.showErrorPopup = true;
      }
      this.showErrorPopup = false;
    }
  }, {
    key: "ClearErrorButton",
    value: function ClearErrorButton() {
      this.appStore.setStateToOk();
      this.showErrorPopup = false;
    }
  }]);
  return Default;
}(Vue);
__decorate([Watch('showError')], Default.prototype, "onErrorChange", null);
__decorate([Watch('showErrorPopup')], Default.prototype, "onVisibilityErrorPopUpChanged", null);
Default = __decorate([Component({
  components: {
    DefaultMenuUser: DefaultMenuUser,
    DefaultMenu: DefaultMenu,
    HorizontalTemplate: HorizontalTemplate,
    SmallMenu: SmallMenu
  }
})], Default);
export default Default;